import type { EventEmitterUtil } from '@chesscom/web-ui';
import type { Game } from 'chessboard/model/game/types';

export namespace Timer {
  export enum Actions {
    Reset = 'Reset',
    Start = 'Start',
    Stop = 'Stop',
    Tick = 'Tick',
  }

  export interface API extends EventEmitterUtil.EventEmitter {
    add(timeInMs: number): void;
    destroy(): void;
    get(): Model;
    reset(newTimeInMs?: number): void;
    start(): void;
    stop(): void;
  }

  export interface Model {
    color?: Game.ColorsAsNumbers;
    currentTime: number;
    lastTickTimestamp: number;
    resetTime: number;
    state: States;
    startTimestamp: number;
    timeSpent: number;
  }

  export interface EmittedData extends Model {
    type: Events;
  }

  export enum Events {
    End = 'End',
    Reset = 'Reset',
    Start = 'Start',
    Stop = 'Stop',
    Tick = 'Tick',
    TimeAdded = 'TimeAdded',
  }

  export enum States {
    Ended = 'Ended',
    Going = 'Going',
    Initial = 'Initial',
    Stopped = 'Stopped',
  }
}
